import React from 'react';
import './AboutUs.css'

const AboutUs = () => {
    return (
        <div>
            <h2 className='text-2xl  font-bold text-center'>About Us</h2>
            <div className="card  bg-base-100 shadow">
                <div className="card-body">
                    <p>
                        MeOnRent Is An Online Library That Offers A Variety Of Membership Options, As The Name Would Imply.
We Have Everything, Whether It Is Fiction, Nonfiction, College Textbooks, Local Materials, Or Magazines.
The Books Will Be In Your Possession In A Day, So You Can Relax, Prepare A Cup Of Tea, And Read Away! You Can Customise Your Plan Based On Your Reading Preferences.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;